/**
 * Kiosk wristband identity + entitlements — proxied by kiosk-service for the
 * self-service /wristband flow. Entitlement items reuse the ticketing-service
 * KioskAttractionTicket wire shape.
 */

import { z } from 'zod';

import { KioskAttractionTicketSchema } from '../ticketing/kiosk-inter-service';

export const EntryTicketSummarySchema = z.object({
  ticketTypeCode: z.string(),
  ticketTypeName: z.string().nullable(),
  category: z.string(),
  visitDate: z.string(),
  status: z.string(),
});

export type EntryTicketSummary = z.infer<typeof EntryTicketSummarySchema>;

/**
 * GET /kiosks/:kioskId/wristband/:wristbandId/identity
 * Mirrors kiosk-service WristbandIdentityService.resolve().
 */
export const KioskWristbandIdentitySchema = z.object({
  wristbandId: z.string(),
  customerName: z.string().nullable(),
  customerEmail: z.string().nullable(),
  ownerId: z.string().nullable(),
  scannedInput: z.string(),
  status: z.string().nullable(),
  ticketId: z.string().nullable(),
  orderId: z.string().nullable(),
  orderNumber: z.string().nullable(),
  entryTicket: EntryTicketSummarySchema.nullable(),
});

export type KioskWristbandIdentity = z.infer<typeof KioskWristbandIdentitySchema>;

/** GET /kiosks/:kioskId/wristband/:wristbandId/entitlements — inner payload after envelope unwrap */
export const KioskWristbandEntitlementsResponseSchema = z.array(KioskAttractionTicketSchema);

export type KioskWristbandEntitlementsResponse = z.infer<
  typeof KioskWristbandEntitlementsResponseSchema
>;
